import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Card, Typography } from '@material-ui/core';
import AcutePatientsByMonth from "./dashboard/AcutePatientsByMonth";
import PatientFacilities from './dashboard/PatientFacilities'
import DischargeDispositionType from './dashboard/DischargeDispositionType';
import CommonModal from './dashboard/CommonModal';
import DrillDownPatient from './dashboard/DrillDownPatient';
import DrillDownFacillity from './dashboard/DrillDownFacillity';
import DrillDownDischarge from './dashboard/DrillDownDischarge';
import { getMonthName } from '../util/DateHelper';

interface PatientDrillDown {
    month: number;
    year: number;
}

interface FacilityDrillDown {
    facilityId: number;
    facilityName: string;
}

interface DischargeDrillDown {
    dischargeType: string;
}

const Home = () => {
    const [patientDrillDown, setPatientDrillDown] = React.useState<PatientDrillDown | null>(null);
    const [facilityDrillDown, setFacilityDrillDown] = React.useState<FacilityDrillDown | null>(null);
    const [dischargeDrillDown, setDischargeDrillDown] = React.useState<DischargeDrillDown | null>(null);

    return (
        <div className="maincontent" style={{ padding: 24 }}>
            <Grid container direction="row" justifyContent="space-between" spacing={3}>
                <Grid item md={12}>
                    <Typography variant="h6" gutterBottom>
                        Patient Population in the last 6 months
                    </Typography>
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                    <Card elevation={3} style={{ padding: 20 }}>
                        <AcutePatientsByMonth openDrillDownModal={(month, year) => setPatientDrillDown({ month, year })} />
                    </Card>
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                    <Card elevation={3} style={{ padding: 20 }}>
                        <PatientFacilities openDrillDownModal={(facilityId, facilityName) => setFacilityDrillDown({ facilityId, facilityName })} />
                    </Card>
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                    <Card elevation={3} style={{ padding: 20 }}>
                        <DischargeDispositionType openDrillDownModal={(dischargeType) => setDischargeDrillDown({ dischargeType })} />
                    </Card>
                </Grid>
            </Grid>

            {/* Drill Down Patient Modal */}
            <CommonModal
                isOpen={patientDrillDown !== null}
                onClose={() => setPatientDrillDown(null)}
                header={patientDrillDown ? `${getMonthName(patientDrillDown.month)} ${patientDrillDown.year}` : ''}
                content={patientDrillDown && <DrillDownPatient month={patientDrillDown.month} year={patientDrillDown.year} />}
            />

            {/* Drill Down Facility Modal */}
            <CommonModal
                isOpen={facilityDrillDown !== null}
                onClose={() => setFacilityDrillDown(null)}
                header={facilityDrillDown?.facilityName ?? ''}
                content={facilityDrillDown && <DrillDownFacillity facilityId={facilityDrillDown.facilityId} />}
            />

            {/* Drill Down Discharge Modal */}
            <CommonModal
                isOpen={dischargeDrillDown !== null}
                onClose={() => setDischargeDrillDown(null)}
                header={dischargeDrillDown?.dischargeType ?? ''}
                content={dischargeDrillDown && <DrillDownDischarge dischargeType={dischargeDrillDown.dischargeType} />}
            />
        </div>
    );
}

export default connect()(Home);
